module.exports = __webpack_public_path__ + "img/portrait2quarter.74da787d.jpg";